import Parse from "parse";

import type { _User } from "./_User";
import type { SIV_DeliveryNotes } from "./SIV_DeliveryNotes";
import type { SIV_GoodsReceiptProcessPosition } from "./SIV_GoodsReceiptProcessPosition";
import type { SIV_Order } from "./SIV_Order";
import type { OD3_Tenant } from "./OD3_Tenant";

export interface SIV_DeliveryNotesPositionAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  changedAt?: Date | undefined;
  changedBy?: _User | undefined;
  deliveryNote?: SIV_DeliveryNotes | undefined;
  goodsReceiptProcessPosition?: SIV_GoodsReceiptProcessPosition | undefined;
  no?: string | undefined;
  notFoundValues: any;
  order?: SIV_Order | undefined;
  quantity?: number | undefined;
  tenant?: OD3_Tenant | undefined;
}

export class SIV_DeliveryNotesPosition extends Parse.Object<SIV_DeliveryNotesPositionAttributes> {
  static className: string = "SIV_DeliveryNotesPosition";

  constructor(data?: Partial<SIV_DeliveryNotesPositionAttributes>) {
    super(
      "SIV_DeliveryNotesPosition",
      data as SIV_DeliveryNotesPositionAttributes,
    );
  }

  get changedAt(): Date | undefined {
    return super.get("changedAt");
  }
  set changedAt(value: Date | undefined) {
    super.set("changedAt", value);
  }

  get changedBy(): _User | undefined {
    return super.get("changedBy");
  }
  set changedBy(value: _User | undefined) {
    super.set("changedBy", value);
  }

  get deliveryNote(): SIV_DeliveryNotes | undefined {
    return super.get("deliveryNote");
  }
  set deliveryNote(value: SIV_DeliveryNotes | undefined) {
    super.set("deliveryNote", value);
  }

  get goodsReceiptProcessPosition():
    | SIV_GoodsReceiptProcessPosition
    | undefined {
    return super.get("goodsReceiptProcessPosition");
  }
  set goodsReceiptProcessPosition(
    value: SIV_GoodsReceiptProcessPosition | undefined,
  ) {
    super.set("goodsReceiptProcessPosition", value);
  }

  get no(): string | undefined {
    return super.get("no");
  }
  set no(value: string | undefined) {
    super.set("no", value);
  }

  get notFoundValues(): any {
    return super.get("notFoundValues");
  }
  set notFoundValues(value: any) {
    super.set("notFoundValues", value);
  }

  get order(): SIV_Order | undefined {
    return super.get("order");
  }
  set order(value: SIV_Order | undefined) {
    super.set("order", value);
  }

  get quantity(): number | undefined {
    return super.get("quantity");
  }
  set quantity(value: number | undefined) {
    super.set("quantity", value);
  }

  get tenant(): OD3_Tenant | undefined {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant | undefined) {
    super.set("tenant", value);
  }
}

Parse.Object.registerSubclass(
  "SIV_DeliveryNotesPosition",
  SIV_DeliveryNotesPosition,
);
